import { ga, outbrain, taboola } from 'js/analytics/adapters'

export function trackInstallClick(device) {
  ga.track('Install', {
    hitType: 'event',
    eventCategory: 'App store buttons',
    eventLabel: device === 'iOS' ? 'App store' : 'Google play',
    eventValue: 3,
  })

  outbrain.track('Add to cart')
  taboola.track('add_to_cart')
}
